import React, { lazy } from "react";

// signin pages
const LoginPage = lazy(() => import("pages/Login"));
const ForgotPasswordPage = lazy(() => import("pages/Login/ForgotPassword"));
const ResetPasswordPage = lazy(() => import("pages/Login/ResetPassword"));
// admin routes
const DashboardPage = lazy(() => import("pages/Dashboard"));
// search page
const GlobalSearchPage = lazy(() => import("pages/GlobalSearch"));
//outlate
const OutlatePage = lazy(() => import("pages/Outlate"));
//lucky-draw
const LuckyDrawPage = lazy(() => import("pages/LuckyDraw"));
// staff
const StaffManagementPage = lazy(() => import("pages/StaffManagement"));
//.... role
const RolePage = lazy(() => import("pages/StaffManagement/Role"));
const AddRolePage = lazy(() => import("pages/StaffManagement/Role/AddRole"));
const EditRolePage = lazy(() => import("pages/StaffManagement/Role/EditRole"));
// staff
const StaffPage = lazy(() => import("pages/StaffManagement/Staff"));
const AddStaffPage = lazy(() => import("pages/StaffManagement/Staff/AddStaff"));
const EditStaffPage = lazy(() =>
  import("pages/StaffManagement/Staff/EditStaff")
);
//Seminar
const SeminarPage = lazy(() => import("pages/Seminar"));
const AddSeminar = lazy(() => import("pages/Seminar/AddSeminar"));
const EditSeminar = lazy(() => import("pages/Seminar/EditSeminar"));
const SeminarBookingPage = lazy(() => import("pages/Seminar/SeminarBooking"));
// const EditSeminar = lazy(() => import("pages/Seminar/EditSeminar"));
// dealers
const DealersPage = lazy(() => import("pages/Dealers"));
const DealerReportPage = lazy(() => import("pages/Dealers/DealersReport"));
const DealerSalesReportPage = lazy(() =>
  import("pages/Dealers/DealersSalesReport")
);
const DealerRedeemableProductsPage = lazy(() =>
  import("pages/Dealers/DealersRedeemableProducts")
);
const DealerPurchaseReportPage = lazy(() =>
  import("pages/Dealers/DealersPurchaseReport")
);

const DealerPointSummaryPage = lazy(() =>
  import("pages/Dealers/DealersReport/DealerPointSummary")
);
const DealerRewardSummaryPage = lazy(() =>
  import("pages/Dealers/DealersReport/DealerRewardSummary")
);
const VerifyDealerAccountPage = lazy(() =>
  import("pages/Dealers/VerifyDealerAccount")
);
// sub dealers
const SubDealersPage = lazy(() => import("pages/SubDealers"));
const SubDealerReportPage = lazy(() =>
  import("pages/SubDealers/SubDealersReport")
);
// const SubDealerRedeemableProductsPage = lazy(() =>
//   import("pages/Dealers/DealersRedeemableProducts")
// );
const SubDealerSalesReportPage = lazy(() =>
  import("pages/SubDealers/SubDealersSalesReport")
);
const SubDealerPurchaseReportPage = lazy(() =>
  import("pages/SubDealers/SubDealersPurchaseReport")
);
const SubDealerRedeemableProductsPage = lazy(() =>
  import("pages/SubDealers/SubDealersRedeemableProducts")
);
const SubDealerPointSummaryPage = lazy(() =>
  import("pages/SubDealers/SubDealersReport/SubDealerPointSummary")
);
const SubDealerRewardSummaryPage = lazy(() =>
  import("pages/SubDealers/SubDealersReport/SubDealerRewardSummary")
);
const VerifySubDealerAccountPage = lazy(() =>
  import("pages/SubDealers/VerifySubDealerAccount")
);
//technicians
const TechniciansPage = lazy(() => import("pages/Technicians"));
const TechniciansReportPage = lazy(() =>
  import("pages/Technicians/TechniciansReport")
);
const TechniciansRedeemableProductsPage = lazy(() =>
  import("pages/Technicians/TechniciansRedeemableProducts")
);
const TechniciansPurchaseReportPage = lazy(() =>
  import("pages/Technicians/TechniciansPurchaseReport")
);
const TechniciansPointSummaryPage = lazy(() =>
  import("pages/Technicians/TechniciansReport/TechnicianPointSummary")
);
const TechniciansRewardSummaryPage = lazy(() =>
  import("pages/Technicians/TechniciansReport/TechnicianRewardSummary")
);
//othermodule
const OtherModulePage = lazy(() => import("pages/OtherModule"));
const LockUserPage = lazy(() => import("pages/OtherModule/LockUser"));
const FultReportPage = lazy(() => import("pages/OtherModule/FultReport"));
const MarqueeReportPage = lazy(() => import("pages/OtherModule/MarqueeReport"));
const TutorialVideo = lazy(() => import("pages/OtherModule/TutorialVideo"));
const TermsAndCondition = lazy(() =>
  import("pages/OtherModule/TermsAndCondition")
);
// const NewReportPage = lazy(() => import("pages/WhatsNewReport/NewReport"));

//banner
const BannerModulePage = lazy(() => import("pages/BannerModule"));
const FirstBanner = lazy(() => import("pages/BannerModule/FirstBanner"));
const SecondBanner = lazy(() => import("pages/BannerModule/SecondBanner"));
const ThirdBanner = lazy(() => import("pages/BannerModule/ThirdBanner"));
const ForthBanner = lazy(() => import("pages/BannerModule/ForthBanner"));
const StartupBanner = lazy(() => import("pages/BannerModule/StartupBanner"));

//reference scheme
const ReferenceSchemePage = lazy(() => import("pages/ReferenceScheme"));
const FixScanReferenceReportPage = lazy(() =>
  import("pages/ReferenceScheme/FixScanReferenceReport")
);
const FixScanReferenceInsertPage = lazy(() =>
  import("pages/ReferenceScheme/FixScanReferenceInsert")
);
const FixScanReferenceUpdatePage = lazy(() =>
  import("pages/ReferenceScheme/FixScanReferenceUpdate")
);
const TargetPointsReferenceReportPage = lazy(() =>
  import("pages/ReferenceScheme/TargetPointsReferenceReport")
);
const TargetPointsReferenceInsertPage = lazy(() =>
  import("pages/ReferenceScheme/TargetPointsReferenceInsert")
);
const TargetPointsReferenceUpdatePage = lazy(() =>
  import("pages/ReferenceScheme/TargetPointsReferenceUpdate")
);
const MilestoneReferencePointsReportPage = lazy(() =>
  import("pages/ReferenceScheme/MilestoneReferencePointsReport")
);
const MilestoneReferencePointsInsertPage = lazy(() =>
  import("pages/ReferenceScheme/MilestoneReferencePointsInsert")
);
const MilestoneReferencePointsUpdatePage = lazy(() =>
  import("pages/ReferenceScheme/MilestoneReferencePointsUpdate")
);
const LevelReferencePointsReportPage = lazy(() =>
  import("pages/ReferenceScheme/LevelReferencePointsReport")
);
const LevelReferencePointsInsertPage = lazy(() =>
  import("pages/ReferenceScheme/LevelReferencePointsInsert")
);
const LevelReferencePointsUpdatePage = lazy(() =>
  import("pages/ReferenceScheme/LevelReferencePointsUpdate")
);
const LevelReferenceAchievedPointsReportPage = lazy(() =>
  import("pages/ReferenceScheme/LevelReferenceAchievedPointsReport")
);
const FixScanAchievedPointsReportPage = lazy(() =>
  import("pages/ReferenceScheme/FixScanAchievedPointsReport")
);
const TargetPointsAchievedPointsReportPage = lazy(() =>
  import("pages/ReferenceScheme/TargetPointsAchievedPointsReport")
);
const MilestonePointsAchievedPointsReportPage = lazy(() =>
  import("pages/ReferenceScheme/MilestonePointsAchievedPointsReport")
);

//whats new report
// const WhatsNewReportModulePage = lazy(() => import("pages/BannerModule"));
const NewReportPage = lazy(() => import("pages/OtherModule/NewReport"));
// const ListNewReportOrder = lazy(() =>
//   import("pages/WhatsNewReport/NewReportOrder")
// );

//reward module
const RewardModulePage = lazy(() => import("pages/RewardModule"));
const ScanRewardPage = lazy(() => import("pages/RewardModule/ScanReward"));
const AddScanRewardPage = lazy(() =>
  import("pages/RewardModule/ScanReward/AddScanReward")
);
const EditScanRewardPage = lazy(() =>
  import("pages/RewardModule/ScanReward/EditScanReward")
);
const CreateBikeRewardPage = lazy(() =>
  import("pages/RewardModule/CreateBikeReward")
);
const ListBikeRewardPage = lazy(() =>
  import("pages/RewardModule/ListBikeReward")
);
const UpdateBikeRewardPage = lazy(() =>
  import("pages/RewardModule/UpdateBikeReward")
);
const CreatePointsRedeemOptionPage = lazy(() =>
  import("pages/RewardModule/CreatePointsRedeemOptions")
);
const ListPointsRedeemOptionPage = lazy(() =>
  import("pages/RewardModule/ListPointsRedeemOptions")
);
const UpdatePointsRedeemOptionPage = lazy(() =>
  import("pages/RewardModule/UpdatePointsRedeemOptions")
);
const DealerBonusPointsReportPage = lazy(() =>
  import("pages/RewardModule/ListDealerBonusPointsReport")
);
const DealerBonusPointsInsertPage = lazy(() =>
  import("pages/RewardModule/CreateDealerBonusPoints")
);
const UpdateDealerBonusPointsPage = lazy(() =>
  import("pages/RewardModule/UpdateDealerBonusPoints")
);
const CongratulationsImageUploadInsertPage = lazy(() =>
  import("pages/RewardModule/CreateCongratulationsImageUpload")
);
const CongratulationsImageUploadListPage = lazy(() =>
  import("pages/RewardModule/ListCongratulationsImageUpload")
);
const CongratulationsImageUploadUpdatePage = lazy(() =>
  import("pages/RewardModule/UpdateCongratulationsImageUpload")
);
const AdminAddPointsOldPage = lazy(() =>
  import("pages/RewardModule/AdminAddPointsOld")
);
const InwardOutwardListPage = lazy(() =>
  import("pages/RewardModule/InwardOutwardList")
);
const TransferHistoryReportPage = lazy(() =>
  import("pages/RewardModule/TransferHistoryReport")
);
const TechniciansFirstRewardReportPage = lazy(() =>
  import("pages/RewardModule/TechniciansFirstRewardReport")
);
//bonus point module
const BonusPointModulePage = lazy(() => import("pages/BonusPointModule"));
const BonusPointAchieverListPage = lazy(() =>
  import("pages/BonusPointModule/BonusPointAchiever")
);
const BonusPointReportList = lazy(() =>
  import("pages/BonusPointModule/BonusPointReport")
);
//profile
const UpdateProfile = lazy(() => import("pages/Profile/UpdateProfile"));
const ReportPage = lazy(() => import("pages/Reports"));
//overall reward report
const OverallRewardReportPage = lazy(() =>
  import("pages/Reports/OverallRewardReport")
);
//lucky draw report
const LuckyDrawReportPage = lazy(() => import("pages/Reports/LuckyDrawReport"));
//otp report
const OtpReportPage = lazy(() => import("pages/Reports/OtpReport"));
//cartreopt
const CartReportPage = lazy(() => import("pages/Reports/CartReport"));
//CompanyDealerReplacedProducts
const DealerReplacedProducts = lazy(() =>
  import("pages/Reports/DealerReplacedProducts")
);
//DealerAdditionalWarranty
const DealerAdditionalWarranty = lazy(() =>
  import("pages/Reports/DealerAdditionalWarranty")
);
//DealerAdditionalWarrantyReplacement
const DealerAdditionalWarrantyReplacement = lazy(() =>
  import("pages/Reports/DealerAdditionalWarrantyReplacement")
);
// MasterRegistrationReport
const MasterRegistrationReport = lazy(() =>
  import("pages/Reports/MasterRegistrationReport")
);
// scan code report
const ScanCodeReportPage = lazy(() => import("pages/Reports/ScanCodeReport"));
// wallet transaction report
const WalletTransactionPage = lazy(() => import("pages/WalletTransaction"));
const AddWalletTransactionPage = lazy(() => import("pages/WalletTransaction/AddWalletTransaction"));
const WalletTransactionReportPage = lazy(() =>
  import("pages/Reports/WalletTransactionReport")
);
// overall reward achieved
const OverallRewardAchievedReportPage = lazy(() =>
  import("pages/Reports/OverallRewardAchievedReport")
);
// overall point achieved
const OverallPointAchievedReportPage = lazy(() =>
  import("pages/Reports/OverallPointAchievedReport")
);
// overall Reward Redeem
const OverallRewardRedeemReportPage = lazy(() =>
  import("pages/Reports/OverallRewardRedeemReport")
);
const OverallBikeRewardReportPage = lazy(() =>
  import("pages/Reports/OverallBikeRewardReport")
);
const AccountLogDetailsReportPage = lazy(() =>
  import("pages/Reports/AccountLogDetailsReport")
);
const ProductScanRewardReportPage = lazy(() =>
  import("pages/Reports/ProductScanRewardReport")
);
// check user detail form
const CheckUserDetailPage = lazy(() =>
  import("pages/Reports/UserDetailReport")
);
// monthwise scan report
const MonthwiseScanPercentageReportPage = lazy(() =>
  import("pages/Reports/MonthwiseScanPercentageReport")
);
const WhatsappMassageReportPage = lazy(() =>
  import("pages/Reports/WhatsappMessageReport")
);
const ReferralUsedCoinReportPage = lazy(() =>
  import("pages/Reports/ReferralUsedCoinReport")
);
//category master
const CategoryMasterPage = lazy(() => import("pages/CategoryMaster"));
const CategoryReportPage = lazy(() =>
  import("pages/CategoryMaster/CategoryReport")
);
const AchievementOrderPage = lazy(() =>
  import("pages/CategoryMaster/AchievementOrder")
);
//catagory
const CatalogPage = lazy(() => import("pages/Catalog"));
const CatalogReportPage = lazy(() => import("pages/Catalog/CatalogReport"));
const CatalogVideo = lazy(() => import("pages/Catalog/CatalogVideo"));
//store
const StorePage = lazy(() => import("pages/Store"));
const StoreCategoryPage = lazy(() => import("pages/Store/StoreCategory"));
const StoreProductPage = lazy(() => import("pages/Store/StoreProduct"));
//fult
const FultPage = lazy(() => import("pages/Fult"));
const DealerToBeReplacementProduct = lazy(() =>
  import("pages/Fult/DealerToBeReplacementProduct")
);
const TechnicianClaimedCompanyWarranty = lazy(() =>
  import("pages/Fult/TechnicianClaimedCompanyWarranty")
);
const ProductGivenWarranty = lazy(() =>
  import("pages/Fult/ProductGivenWarranty")
);
const EditProductDetail = lazy(() =>
  import("pages/Fult/UpdateDealerToBeReplacementProduct")
);
//fivestar levels
const FiveStarLevelsPage = lazy(() => import("pages/FiveStarLevels"));
const FiveStarLevelsList = lazy(() =>
  import("pages/FiveStarLevels/FiveStarLevels")
);
const FiveStarLevelsConditions = lazy(() =>
  import("pages/FiveStarLevels/FiveStarLevelsConditions")
);
const FiveStarGift = lazy(() => import("pages/FiveStarLevels/FiveStarGift"));
const FiveStarReportsPage = lazy(() => import("pages/FiveStarReport"));
const FiveStarReport = lazy(() =>
  import("pages/FiveStarReport/FiveStarReport")
);
const FiveStarGiftReport = lazy(() =>
  import("pages/FiveStarReport/FiveStarGiftReport")
);
const FiveStarGiftWhatsappMessagesReport = lazy(() =>
  import("pages/FiveStarReport/FiveStarGiftWhatsappMessagesReport")
);
// master barcode
const MasterBarcodeReportsPage = lazy(() => import("pages/MasterBarcodeReport"));
const MasterBarcodeReport = lazy(() =>
  import("pages/MasterBarcodeReport/MasterBarcodeReport")
);
const MasterBarcodeBalanceReport = lazy(() =>
  import("pages/MasterBarcodeReport/MasterBarcodeBalanceReport")
);
const MasterBarcodeReportDetails = lazy(() =>
  import("pages/MasterBarcodeReport/MasterBarcodeReoprtDetails")
);
//notification
const NotificationPage = lazy(() => import("pages/Notification"));
//manual notification
const ManualNotificationPage = lazy(() =>
  import("pages/Notification/ManualNotification")
);
const TicketDetailPage = lazy(() => import("pages/Tickets"));
const AddManualNotification = lazy(() =>
  import("pages/Notification/ManualNotification/AddManualNotification")
);
const EditManualNotification = lazy(() =>
  import("pages/Notification/ManualNotification/EditManualNotification")
);
// const EditManualNotification = lazy(() =>
//   import("pages/Notification/ManualNotification/EditManualNotification")
// );
//lucky draw campaign
const LuckyDrawCampaignPage = lazy(() => import("pages/LuckyDrawCampaign"));
const Quarter2022JulAugPage = lazy(() =>
  import("pages/LuckyDrawCampaign/Quarter2022JulAug")
);
const Quarter2022OctDecPage = lazy(() =>
  import("pages/LuckyDrawCampaign/Quarter2022OctDec")
);
const EligibleTechnicianLuckyDrawReport = lazy(() =>
  import("pages/LuckyDrawCampaign/EligibleTechnicianLuckyDrawReport")
);
const EligibleTechnicianLuckyDrawReportOctDec = lazy(() =>
  import("pages/LuckyDrawCampaign/EligibleTechnicianLuckyDrawReportOctDec")
);
const LuckyDrawDetailsPage = lazy(() =>
  import("pages/LuckyDrawCampaign/LuckyDrawDetails")
);
//setting
const SettingPage = lazy(() => import("pages/SettingsModule"));
const MaintenanceSettingPage = lazy(() =>
  import("pages/SettingsModule/MaintenanceSetting")
);
const WhatsappNotificationSettingPage = lazy(() =>
  import("pages/SettingsModule/WhatsappNotificationSetting")
);
const AutoNotificationSettingPage = lazy(() =>
  import("pages/SettingsModule/AutoNotificationSettings")
);
const SocialMediaSettingPage = lazy(() =>
  import("pages/SettingsModule/SocialMediaSetting")
);
export const techniciansRoutes = {
  techniciansReportList: {
    path: "technicians-report",
    element: <TechniciansReportPage />,
  },
  techniciansRedeemableProductsList: {
    path: "technicians-redeemable-products",
    element: <TechniciansRedeemableProductsPage />,
  },
  techniciansPurchaseReportList: {
    path: "technicians-purchase-report",
    element: <TechniciansPurchaseReportPage />,
  },
  techniciansPointSummaryList: {
    path: "technicians-report/technician-point-summary/:id",
    element: <TechniciansPointSummaryPage />,
  },
  techniciansRewardSummaryList: {
    path: "technicians-report/technician-reward-summary/:id",
    element: <TechniciansRewardSummaryPage />,
  },
};
export const otherModulRoutes = {
  lockUserList: {
    path: "lock-user",
    element: <LockUserPage />,
  },
  fultReportList: {
    path: "fult-report",
    element: <FultReportPage />,
  },
  marqueeReportList: {
    path: "marquee-report",
    element: <MarqueeReportPage />,
  },
  newReportList: {
    path: "whats-new-report",
    element: <NewReportPage />,
  },
  tutorialVideoList: {
    path: "tutorial-video",
    element: <TutorialVideo />,
  },
  TermsAndCondition: {
    path: "terms-and-condition",
    element: <TermsAndCondition />,
  },
};
export const bannnerModulRoutes = {
  firstBanner: {
    path: "first-banner",
    element: <FirstBanner />,
  },
  secondBanner: {
    path: "second-banner",
    element: <SecondBanner />,
  },
  thirdBanner: {
    path: "third-banner",
    element: <ThirdBanner />,
  },
  forthBanner: {
    path: "forth-banner",
    element: <ForthBanner />,
  },
  startupBanner: {
    path: "startup-Banner",
    element: <StartupBanner />,
  },
};
// export const whatsNewReportModulRoutes = {
//   newReportList: {
//     path: "whats-new-report",
//     element: <NewReportPage />,
//   },
//   newReportOrder: {
//     path: "new-report-order",
//     element: <ListNewReportOrder />,
//   },
// };
export const referenceSchemeRoutes = {
  fixScanReferenceReport: {
    path: "fix-scan-reference-report",
    element: <FixScanReferenceReportPage />,
  },
  fixScanReferenceInsert: {
    path: "fix-scan-reference-insert",
    element: <FixScanReferenceInsertPage />,
  },
  fixScanReferenceUpdate: {
    path: "fix-scan-reference-update/:id",
    element: <FixScanReferenceUpdatePage />,
  },
  targetPointsReferenceReport: {
    path: "target-points-reference-report",
    element: <TargetPointsReferenceReportPage />,
  },
  targetPointsReferenceInsert: {
    path: "target-points-reference-insert",
    element: <TargetPointsReferenceInsertPage />,
  },
  targetPointsReferenceUpdate: {
    path: "target-points-reference-update/:id",
    element: <TargetPointsReferenceUpdatePage />,
  },
  milestoneReferencePointsReport: {
    path: "milestone-reference-points-report",
    element: <MilestoneReferencePointsReportPage />,
  },
  milestoneReferencePointsInsert: {
    path: "milestone-reference-points-insert",
    element: <MilestoneReferencePointsInsertPage />,
  },
  milestoneReferencePointsUpdate: {
    path: "milestone-reference-points-update/:id",
    element: <MilestoneReferencePointsUpdatePage />,
  },
  levelReferencePointsReport: {
    path: "level-reference-points-report",
    element: <LevelReferencePointsReportPage />,
  },
  levelReferencePointsInsert: {
    path: "level-reference-points-insert",
    element: <LevelReferencePointsInsertPage />,
  },
  levelReferencePointsUpdate: {
    path: "level-reference-points-update/:id",
    element: <LevelReferencePointsUpdatePage />,
  },
  levelReferenceAchievedPointsReport: {
    path: "level-reference-achieved-points-report",
    element: <LevelReferenceAchievedPointsReportPage />,
  },
  fixScanAchievedPointsReport: {
    path: "fix-scan-achieved-points-report",
    element: <FixScanAchievedPointsReportPage />,
  },
  targetPointsAchievedPointsReport: {
    path: "target-points-achieved-points-report",
    element: <TargetPointsAchievedPointsReportPage />,
  },
  milestonePointsAchievedPointsReport: {
    path: "milestone-points-achieved-points-report",
    element: <MilestonePointsAchievedPointsReportPage />,
  },
};
export const rewardModulRoutes = {
  scanReward: {
    path: "scan-reward",
    element: <ScanRewardPage />,
  },
  addScanReward: {
    path: "add-scan-reward",
    element: <AddScanRewardPage />,
  },
  updateScanReward: {
    path: "edit-scan-reward/:id",
    element: <EditScanRewardPage />,
  },
  createBikeReward: {
    path: "create-bike-reward",
    element: <CreateBikeRewardPage />,
  },
  updateBikeReward: {
    path: "update-bike-reward/",
    element: <ListBikeRewardPage />,
  },
  updateBikeRewardById: {
    path: "update-bike-reward/:id",
    element: <UpdateBikeRewardPage />,
  },
  createPointsRedeemOptions: {
    path: "create-points-redeem-options",
    element: <CreatePointsRedeemOptionPage />,
  },
  listPointsRedeemOptions: {
    path: "list-points-redeem-options",
    element: <ListPointsRedeemOptionPage />,
  },
  updatePointsRedeemOptions: {
    path: "update-points-redeem-options/:id",
    element: <UpdatePointsRedeemOptionPage />,
  },
  dealerBonusPointsReport: {
    path: "dealer-bonus-points-report",
    element: <DealerBonusPointsReportPage />,
  },
  dealerBonusPointsInsert: {
    path: "dealer-bonus-points-insert",
    element: <DealerBonusPointsInsertPage />,
  },
  updateDealerBonusPoints: {
    path: "update-dealer-bonus-points",
    element: <UpdateDealerBonusPointsPage />,
  },
  congratulationsImageUploadReport: {
    path: "congratulations-image-upload-list",
    element: <CongratulationsImageUploadListPage />,
  },
  congratulationsImageUploadInsert: {
    path: "congratulations-image-upload-insert",
    element: <CongratulationsImageUploadInsertPage />,
  },
  congratulationsImageUploadUpdate: {
    path: "congratulations-image-upload-update/:id",
    element: <CongratulationsImageUploadUpdatePage />,
  },
  adminAddPointsOld: {
    path: "admin-add-points-old",
    element: <AdminAddPointsOldPage />,
  },
  inwardOutwardList: {
    path: "inward-outward-list",
    element: <InwardOutwardListPage />,
  },
  transferHistoryReport: {
    path: "transfer-history-report",
    element: <TransferHistoryReportPage />,
  },
  techniciansFirstRewardReport: {
    path: "technicians-first-reward-list",
    element: <TechniciansFirstRewardReportPage />,
  },
};
export const bonusPointModulRoutes = {
  bonusPointAchieverList: {
    path: "bonus-point-achiever",
    element: <BonusPointAchieverListPage />,
  },
  bonusPointReportList: {
    path: "bonus-point-report",
    element: <BonusPointReportList />,
  },
};
// export const BonusPointReportRoutes = {
//   bonusPointReportList: {
//     path: "bonus-point-report",
//     element: <BonusPointReportList />,
//   },
// };
export const fultRoutes = {
  dealerToBeReplacementProduct: {
    path: "dealer-to-be-replacement-product",
    element: <DealerToBeReplacementProduct />,
  },
  technicianClaimedCompanyWarranty: {
    path: "technician-claimed-company-warranty",
    element: <TechnicianClaimedCompanyWarranty />,
  },
  productGivenWarranty: {
    path: "product-given-warranty",
    element: <ProductGivenWarranty />,
  },
  editProductDetails: {
    path: "edit-product-details/:id",
    element: <EditProductDetail />,
  },
};
export const luckyDrawCampaignRoutes = {
  quarter2022JulAug: {
    path: "quarter-2022-jul-aug",
    element: <Quarter2022JulAugPage />,
  },
  quarter2022OctDec: {
    path: "quarter-2022-oct-dec",
    element: <Quarter2022OctDecPage />,
  },
  eligibleTechnicianLuckyDrawReport: {
    path: "eligible-technician-lucky-draw-report",
    element: <EligibleTechnicianLuckyDrawReport />,
  },
  eligibleTechnicianLuckyDrawReportOctDec: {
    path: "eligible-technician-lucky-draw-report-oct-dec",
    element: <EligibleTechnicianLuckyDrawReportOctDec />,
  },
  luckyDrawDetailsPage: {
    path: "lucky-draw-details-page/:id",
    element: <LuckyDrawDetailsPage />,
  },
};
export const fiveStarLevelsRoutes = {
  fiveStarLevels: {
    path: "fivestar-levels-list",
    element: <FiveStarLevelsList />,
  },
  fiveStarLevelsConditions: {
    path: "fivestar-levels-conditions",
    element: <FiveStarLevelsConditions />,
  },
  fiveStarGift: {
    path: "fivestar-gift",
    element: <FiveStarGift />,
  },
};
export const fiveStarReportsRoutes = {
  fiveStarReport: {
    path: "fivestar-report",
    element: <FiveStarReport />,
  },
  fiveStarGiftReport: {
    path: "fivestar-gift-report",
    element: <FiveStarGiftReport />,
  },
  fiveStarGiftWhatsappMessagesReport: {
    path: "fivestar-gift-whatsapp-messages-report",
    element: <FiveStarGiftWhatsappMessagesReport />,
  },
};
export const masterBarcodeReportRoutes = {
  masterBarcodeReport: {
    path: "master-barcode-report",
    element: <MasterBarcodeReport />,
  },
  masterBarcodeBalanceReport: {
    path: "master-barcode-balance-report",
    element: <MasterBarcodeBalanceReport />,
  },
  masterBarcodeReportDetails: {
    path: "master-barcode-report-details/:id",
    element: <MasterBarcodeReportDetails />,
  },
}
export const notificationRoutes = {
  manualNotification: {
    path: "manual-notification",
    element: <ManualNotificationPage />,
  },
  addMenualNotification: {
    path: "add-manual-notification",
    element: <AddManualNotification />,
  },
  updateMenualNotification: {
    path: "edit-manual-notification/:id",
    element: <EditManualNotification />,
  },
};
export const settingRoutes = {
  maintenanceSettingList: {
    path: "maintenance-setting",
    element: <MaintenanceSettingPage />,
  },
  whatsappNotificationSettingList: {
    path: "whatsapp-notification",
    element: <WhatsappNotificationSettingPage />,
  },
  autoNotificationSettingList: {
    path: "auto-notification",
    element: <AutoNotificationSettingPage />,
  },
  socialMediaSettingPageList: {
    path: "social-media",
    element: <SocialMediaSettingPage />,
  },
};
export const reportRoutes = {
  overallRewardReportList: {
    path: "overall-reward-report",
    element: <OverallRewardReportPage />,
  },
  luckyDrawReportList: {
    path: "lucky-draw-report",
    element: <LuckyDrawReportPage />,
  },
  otpReportList: {
    path: "otp-report",
    element: <OtpReportPage />,
  },
  cartReportList: {
    path: "cart-report",
    element: <CartReportPage />,
  },
  DealerReplacedProductsList: {
    path: "Company-Dealer-Replaced-Products-report",
    element: <DealerReplacedProducts />,
  },
  DealerAdditionalWarrantyList: {
    path: "Dealer-Additional-Warranty",
    element: <DealerAdditionalWarranty />,
  },
  DealerAdditionalWarrantyReplacementList: {
    path: "Dealer-Replacement-Additional-Warranty",
    element: <DealerAdditionalWarrantyReplacement />,
  },
  MasterRegistrationReportList: {
    path: "Master-Registration-Report",
    element: <MasterRegistrationReport />,
  },
  scanCodeReportList: {
    path: "scan-code-report",
    element: <ScanCodeReportPage />,
  },
  walletTransactionReportList: {
    path: "wallet-transaction-report",
    element: <WalletTransactionReportPage />,
  },
  whatsappMessageReportList: {
    path: "whatsapp-massage-report",
    element: <WhatsappMassageReportPage />,
  },
  checkUserDetail: {
    path: "check-user-detail",
    element: <CheckUserDetailPage />,
  },
  monthwiseScanPercentageReport: {
    path: "monthwise-scan-percentage-report",
    element: <MonthwiseScanPercentageReportPage />,
  },
  overallRewardAchievedList: {
    path: "overall-reward-achieved",
    element: <OverallRewardAchievedReportPage />,
  },
  overallPointAchievedList: {
    path: "overall-point-achieved",
    element: <OverallPointAchievedReportPage />,
  },
  overallRewardRedeemList: {
    path: "overall-reward-redeem",
    element: <OverallRewardRedeemReportPage />,
  },
  overallBikeRewardList: {
    path: "overall-bike-reward",
    element: <OverallBikeRewardReportPage />,
  },
  accountLogDetailsList: {
    path: "account-log-details",
    element: <AccountLogDetailsReportPage />,
  },
  productScanRewardReport: {
    path: "product-scan-reward-report",
    element: <ProductScanRewardReportPage />,
  },
  referralUsedCoinReportList: {
    path: "referral-used-report",
    element: <ReferralUsedCoinReportPage />,
  },
  walletTransactionList: {
    path: "wallet-transaction",
    element: <WalletTransactionPage />,
  },
  addWalletTransaction: {
    path: "add-wallet-transaction",
    element: <AddWalletTransactionPage />,
  },
};
export const categoryMasterRoutes = {
  categoryReportList: {
    path: "category-report",
    element: <CategoryReportPage />,
  },
  achievementOrderList: {
    path: "achievement-order",
    element: <AchievementOrderPage />,
  },
};
export const catalogRoutes = {
  catalogReportList: {
    path: "catalog-report",
    element: <CatalogReportPage />,
  },
  CatalogVideo: {
    path: "catalog-video",
    element: <CatalogVideo />,
  },
};
export const storeRoutes = {
  storeCategoryList: {
    path: "store-category",
    element: <StoreCategoryPage />,
  },
  storeProductList: {
    path: "store-product",
    element: <StoreProductPage />,
  },
}
export const subDealerRoutes = {
  subDealerReportList: {
    path: "sub-dealer-report",
    element: <SubDealerReportPage />,
  },
  subDealerRedeemableProductsList: {
    path: "dealer-redeemable-products",
    element: <SubDealerRedeemableProductsPage />,
  },
  subDealerSalesReportList: {
    path: "sub-dealer-sales-report",
    element: <SubDealerSalesReportPage />,
  },
  subDealerPurchaseReportList: {
    path: "sub-dealer-purchase-report",
    element: <SubDealerPurchaseReportPage />,
  },
  VerifySubDealerAccountList: {
    path: "sub-dealer-account",
    element: <VerifySubDealerAccountPage />,
  },
  subDealerPointSummaryList: {
    path: "sub-dealer-report/sub-dealer-point-summary/:id",
    element: <SubDealerPointSummaryPage />,
  },
  subDealerRewardSummaryList: {
    path: "sub-dealer-report/sub-dealer-reward-summary/:id",
    element: <SubDealerRewardSummaryPage />,
  },
};
export const dealerRoutes = {
  dealerReportList: { path: "dealer-report", element: <DealerReportPage /> },
  dealerRedeemableProductsList: {
    path: "dealer-redeemable-products",
    element: <DealerRedeemableProductsPage />,
  },
  dealerSalesReportList: {
    path: "dealer-sales-report",
    element: <DealerSalesReportPage />,
  },
  dealerPurchaseReportList: {
    path: "dealer-purchase-report",
    element: <DealerPurchaseReportPage />,
  },
  VerifyDealerAccountList: {
    path: "verify-dealer-account",
    element: <VerifyDealerAccountPage />,
  },
  dealerPointSummaryList: {
    path: "dealer-report/dealer-point-summary/:id",
    element: <DealerPointSummaryPage />,
  },
  dealerRewardSummaryList: {
    path: "dealer-report/dealer-reward-summary/:id",
    element: <DealerRewardSummaryPage />,
  },
};
export const staffRoutes = {
  roleList: { path: "role", element: <RolePage /> },
  addRole: { path: "add-role", element: <AddRolePage /> },
  updateRole: { path: "edit-role/:id", element: <EditRolePage /> },
  staffList: { path: "staff-list", element: <StaffPage /> },
  addStaff: { path: "add-staff", element: <AddStaffPage /> },
  updateStaff: { path: "edit-staff/:id", element: <EditStaffPage /> },
};
export const mainRoutes = {
  dashboard: { path: "/", element: <DashboardPage /> },
  globalSearch: { path: "/global-search", element: <GlobalSearchPage /> },
  // role
  // role: { path: "/role", element: <RolePage /> },
  staff: {
    path: "/staff",
    element: <StaffManagementPage />,
    routes: staffRoutes,
  },
  //
  outlate: { path: "/outlate", element: <OutlatePage /> },
  luckyDraw: { path: "/lucky-draw", element: <LuckyDrawPage /> },

  seminar: { path: "/seminar", element: <SeminarPage /> },
  addSeminar: { path: "/add-seminar", element: <AddSeminar /> },
  updateSeminar: { path: "/edit-seminar/:id", element: <EditSeminar /> },

  seminarBokking: {
    path: "/seminar-booking/:id",
    element: <SeminarBookingPage />,
  },
  // editSeminar: { path: "/edit-seminar", element: <EditSeminar /> },
  updateprofile: { path: "/update-profile", element: <UpdateProfile /> },
  dealer: {
    path: "/dealer",
    element: <DealersPage />,
    routes: dealerRoutes,
  },
  subDealer: {
    path: "/sub-dealer",
    element: <SubDealersPage />,
    routes: subDealerRoutes,
  },
  technicians: {
    path: "/technicians",
    element: <TechniciansPage />,
    routes: techniciansRoutes,
  },
  otherModule: {
    path: "/other",
    element: <OtherModulePage />,
    routes: otherModulRoutes,
  },
  bannerModule: {
    path: "/banner",
    element: <BannerModulePage />,
    routes: bannnerModulRoutes,
  },
  referenceScheme: {
    path: "/reference",
    element: <ReferenceSchemePage />,
    routes: referenceSchemeRoutes,
  },
  // WhatsNewReportModule: {
  //   path: "/whats-new-report",
  //   element: <WhatsNewReportModulePage />,
  //   routes: whatsNewReportModulRoutes,
  // },
  rewardModule: {
    path: "/reward",
    element: <RewardModulePage />,
    routes: rewardModulRoutes,
  },
  bonusPointModule: {
    path: "/bonus-point",
    element: <BonusPointModulePage />,
    routes: bonusPointModulRoutes,
  },
  reports: {
    path: "/reports",
    element: <ReportPage />,
    routes: reportRoutes,
  },
  store: {
    path: "/store",
    element: <StorePage />,
    routes: storeRoutes,
  },
  CategoryMaster: {
    path: "/category-master",
    element: <CategoryMasterPage />,
    routes: categoryMasterRoutes,
  },
  Catalog: {
    path: "/catalog",
    element: <CatalogPage />,
    routes: catalogRoutes,
  },
  Setting: {
    path: "/setting",
    element: <SettingPage />,
    routes: settingRoutes,
  },
  Notification: {
    path: "/notification",
    element: <NotificationPage />,
    routes: notificationRoutes,
  },
  ticketDetail: { path: "/ticket-detail/:id", element: <TicketDetailPage /> },
  luckyDrawCampaign: {
    path: "/lucky-draw-campaign",
    element: <LuckyDrawCampaignPage />,
    routes: luckyDrawCampaignRoutes,
  },
  fiveStarLevelsModule: {
    path: "/fivestar-levels",
    element: <FiveStarLevelsPage />,
    routes: fiveStarLevelsRoutes,
  },
  fiveStarReportsModule: {
    path: "/fivestar-reports",
    element: <FiveStarReportsPage />,
    routes: fiveStarReportsRoutes,
  },
  masterBarcodeReportModule: {
    path: "/master-barcode-report",
    element: <MasterBarcodeReportsPage />,
    routes: masterBarcodeReportRoutes,
  },
  Fult: {
    path: "/fult",
    element: <FultPage />,
    routes: fultRoutes,
  },
};

export const loginRoutes = {
  login: { path: "/login", element: <LoginPage /> },
  forgotPassword: { path: "/forgot-password", element: <ForgotPasswordPage /> },
  resetPassword: { path: "/reset-password", element: <ResetPasswordPage /> },
};
